import React from 'react'
import { FormattedDate } from 'react-intl'
import { ProductContainer } from './components/Styled'
import { Link } from 'react-router-dom'
import { Price } from 'lib/shared/components'
import { CustomCartItem as CartItem } from 'data/cartItems'
import { useCartSubscriptions } from 'hooks/cart'
import { MagentoSelectedConfigurableOption as SelectedConfigurableOption } from 'lib/types'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { PACKAGE } from 'resources/constants'
import { getPackageLabel } from 'resources/helpers'

interface Props {
  cartItem: CartItem
  index: number
  hasVariant?: boolean
  itemQty?: number
  variantOptions?: SelectedConfigurableOption[]
  imageUrl?: string
  isChildren?: boolean
  isSpecialSupply?: boolean
  isSubscriptionItem?: boolean
  sampleDuration?: string
  isMiniCart?: boolean
}

export const ItemData = ({
  cartItem,
  index,
  hasVariant = false,
  itemQty,
  variantOptions,
  imageUrl,
  isChildren,
  isSpecialSupply,
  isSubscriptionItem,
  sampleDuration,
  isMiniCart
}: Props) => {
  const {
    product,
    shipmentFrequency,
    packageQty,
    associatedProduct,
    cartItemPrice,
    itemSubtotalWithDiscount
  } = useCartSubscriptions(cartItem)

  const productName = isSpecialSupply ? `${product.name} - ${associatedProduct?.product.name}` : product.name
  const subscriptionStartingDate = sampleDuration && new Date(new Date().setDate(new Date().getDate() + parseInt(sampleDuration)))
  const promoQty = cartItem.promoQty
  const [packageType] = product.customAttribute?.package ?? []
  const isEach = packageType === PACKAGE.EACH

  return (
    <ProductContainer key={index} isChild={isChildren} isMiniCart={isMiniCart}>
      {!isChildren && (
        <div className='product-image'>
          <Link to={product.getUrlPath()}>
            <div
              style={{
                backgroundImage: `url(${imageUrl})`
              }}
            />
          </Link>
        </div>
      )}

      <div className='product-data'>
        <h2>{productName}</h2>
        {isSpecialSupply && (
          <strong>Special Offer</strong>
        )}
        {isSubscriptionItem && (
          <strong>Subscription</strong>
        )}
        {(isSubscriptionItem ?? isSpecialSupply) ? (
          <>
            <p>
              <strong>
                {!isSpecialSupply && (
                  <>
                    Ships every {shipmentFrequency} weeks
                    {!isMiniCart && isChildren && subscriptionStartingDate && (
                      <span className='starting-note'>
                        <span>, starting</span>
                        <FormattedDate
                          value={subscriptionStartingDate}
                          month='2-digit'
                          day='2-digit'
                        />
                      </span>
                    )}
                    <br />
                  </>
                )}
                {isEach ? (
                  <>{isSpecialSupply ? promoQty : itemQty} pieces</>
                ) : (
                  <>{isSpecialSupply ? promoQty : itemQty} {packageType} of {packageQty} pieces</>
                )}
              </strong>
            </p>
          </>
        ) : (
          <>
            {packageQty && parseInt(packageQty?.[0]) > 1 && (
              <p>
                <strong>
                  {packageQty}
                  <span> {getPackageLabel(packageType)}</span>
                </strong>
              </p>
            )}
            {itemQty && <p><strong>Qty {itemQty}</strong></p>}
          </>
        )}
        {hasVariant && variantOptions?.map((option: SelectedConfigurableOption, i: number) => {
          return (
            <p key={i}><strong>{option?.value_label}</strong></p>
          )
        })}
        {isMiniCart && (
          <>
            {isSpecialSupply ? (
              <Price
                currency={DEFAULT_CURRENCY_CODE}
                value={isSpecialSupply ? cartItemPrice : itemSubtotalWithDiscount}
              />
            ) : (
              <>
                {cartItem.quantity} x <Price currency={DEFAULT_CURRENCY_CODE} value={isSpecialSupply ? cartItemPrice : itemSubtotalWithDiscount} />
              </>
            )}
          </>
        )}
      </div>
    </ProductContainer>
  )
}
